
export default {
  props: {
    details: Array,
  },
};
